// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Gg6a","left":"styles_left__22GYD"};